import { render, staticRenderFns } from "./dy_user_list.vue?vue&type=template&id=4ba70493"
import script from "./dy_user_list.vue?vue&type=script&lang=js"
export * from "./dy_user_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports